<template>
  <div class="drinks-window-component">
    <menu-items-list :items="upsaleMenuItems" :loading="isLoading">
      <template v-slot:before-menu-items>
        <h1 class="font-weight-regular">
          Допродажи к заказу:
        </h1>
        <div class="button-group d-flex justify-between">
          <v-row class="justify-space-between">
            <v-col sm="5">
              <v-btn
                class="button button-back"
                width="100%"
                color="#F1F3F6"
                @click="goBack"
              >
                <font-awesome-icon icon="chevron-left" />
                Вернуться назад
              </v-btn>
            </v-col>
            <!--            <v-col sm="5">
              <v-btn
                class="button button-edit"
                width="100%"
                color="#F1F3F6"
                :loading="isLoading"
                @click="goToEdit"
              >
                <font-awesome-icon icon="edit" />
                Редактировать
              </v-btn>
            </v-col>-->
          </v-row>
        </div>
      </template>
    </menu-items-list>
  </div>
</template>

<script>
  import MenuItemsList from '@/components/order-processing/order-components/restourant-menu/MenuItemsList'
  import OrderEdit from '@/mixins/order-edit'
  import editSessionApi from '@/api/order/edit-session'

  export default {
    name: 'UpsalesWindow',
    components: {
      MenuItemsList,
    },
    mixins: [OrderEdit],
    data () {
      return {
        upsaleMenuItems: [],
        isLoading: false,
      }
    },
    created () {
      if (this.upsaleMenuItems.length === 0) {
        this.loadUpsaleItems()
      }
    },
    methods: {
      goToEdit () {
        editSessionApi.open(this.orderId)
        this.$router.push({
          path: '/edit-order',
          query: {
            id: this.orderId,
          },
        })
      },
      goBack () {
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
        this.$store.commit('newOrder/setCurrentOtherWindow', undefined)
      },
      async loadUpsaleItems () {
        this.isLoading = true
        // try {
        this.upsaleMenuItems = await this.$store.dispatch('menuItems/fetchMenuItemsUpsalesList')
        // } catch (err) {
        // this.showErrorFromResponse(err)
        // }
        this.isLoading = false
      },
    },
  }
</script>

<style lang="less" scoped>
  .drinks-window-component {
    background-color: transparent;

    h1 {
      font-size: 34px;
      line-height: 1;
      margin-bottom: 33px;
    }

    .menu-items {
      position: relative;
      z-index: 0;
    }

    .button {
      height: 80px;
      border-radius: 10px;

      svg {
        margin-right: 8px;
      }
    }

    .button-group {
      margin-bottom: 30px;

      .button {
        font-size: 15px;
        box-shadow: 0 3px 6px #00000029 !important;
      }

      .button-back {
        svg {
          .fill-svg(#0033ff);
        }
      }

      .button-edit {
        color: @color-primary;

        svg {
          .fill-svg(@color-primary);
        }
      }
    }
  }
</style>
